import axios from 'axios';

export default {

    Chat: {
        //获取对话列表
        GetChatList(data){
            return axios.post('/api/Chat/GetChatList', data);
        },
        //获取对话记录列表
        GetChatRecordList(data){
            return axios.post('/api/Chat/GetChatRecordList', data);
        },
        //修改话对标题
        UpdateChatTitle(data){
            return axios.post('/api/Chat/UpdateChatTitle', data);
        },
        //置顶/取消置顶
        SetTop(data){
            return axios.post('/api/Chat/SetTop', data);
        },
        //删除对话
        DelChat(data){
            return axios.post('/api/Chat/DelChat', data);
        },
        //音频转文字
        AudioToWords(data){
            return axios.post('/api/Chat/AudioToWords', data);
        },
        //获取微信JSSDK参数
        GetWechatJSSDKParameters(data){
            return axios.post('/api/OpenAuth/GetWechatJSSDKParameters', data);
        },
        //获取对话记录列表用于分享
        GetChatRecordListToShare(data){
            return axios.post('/api/Chat/GetChatRecordListToShare', data);
        },
        //获取问题类别
        GetQuestionCategoryList(data){
            return axios.post('/api/Chat/GetQuestionCategoryList',data);
        },
        //获取问题信息
        GetQuestionList(data){
            return axios.post('/api/Chat/GetQuestionList',data);
        },

        
    }
}